import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleIdentityService } from 'src/app/services/identity.service';
import { AdvancedDebugging } from 'src/app/utilities';

const OP_MENU_NAVIGATE = 'dashboard:DashboardNavbarFacade.navigate';
const OP_LOGOUT = 'dashboard:DashboardNavbarFacade.onLogoutClick';
const OP_LOGOUT_NAVIGATE = 'dashboard:DashboardNavbarFacade.logoutNavigate';

/** Dashboard top nav menu + logout; scoped to {@link NavbarComponent} via `providers`. */
@Injectable()
export class DashboardNavbarFacade {
	private readonly identityService = inject(GoogleIdentityService);
	private readonly router = inject(Router);
	private readonly advancedDebugging = new AdvancedDebugging();

	onMenuClick(itemId: string | undefined): void {
		if (!itemId) {
			return;
		}
		void this.router.navigate([itemId]).catch(error =>
			this.advancedDebugging.captureError(OP_MENU_NAVIGATE, error, {
				tags: { operation: OP_MENU_NAVIGATE, app: 'dashboard' },
				itemId,
			}),
		);
	}

	onLogoutClick(): void {
		try {
			this.identityService.signOut();
		} catch (error) {
			this.advancedDebugging.captureError(OP_LOGOUT, error, {
				tags: { operation: OP_LOGOUT, app: 'dashboard' },
			});
			return;
		}
		void this.router.navigate(['sign-in']).catch(error =>
			this.advancedDebugging.captureError(OP_LOGOUT_NAVIGATE, error, {
				tags: { operation: OP_LOGOUT_NAVIGATE, app: 'dashboard' },
			}),
		);
	}
}
